import React, { useState, useEffect, useRef } from "react"
import { Input } from "~/react/ui/input"
import { Icon } from "~/react/ui/icon"

const t = (key: string) => window.i18n.t(key)

interface AcvFilterProps {
  value: number | null
  onChange: (value: number | null) => void
}

export function AcvFilter({ value, onChange }: AcvFilterProps) {
  const [inputValue, setInputValue] = useState<string>(value?.toString() || "")
  const inputRef = useRef<HTMLInputElement>(null)

  // Sync input value with prop changes
  useEffect(() => {
    setInputValue(value?.toString() || "")
  }, [value])

  // Autofocus when empty (only on initial mount)
  useEffect(() => {
    if (!value && inputRef.current) {
      // Small delay to ensure component is rendered
      const timeoutId = setTimeout(() => {
        inputRef.current?.focus()
      }, 100)
      return () => clearTimeout(timeoutId)
    }
  }, []) // Empty dependency array - only run on mount

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    setInputValue(newValue)

    // Parse and validate the input
    const parsed = parseFloat(newValue)
    if (newValue === "" || isNaN(parsed)) {
      onChange(null)
    } else if (parsed >= 0) {
      onChange(parsed)
    }
  }

  return (
    <div className="tam-calculator__acv-field">
      <label htmlFor="tam-acv-input" className="tam-calculator__acv-label">
        <Icon icon="dollar" size="sm" className="tam-calculator__acv-icon" />
        {t("js.visitors.tam_calculator.filters.acv.label")}
      </label>
      <Input
        ref={inputRef}
        id="tam-acv-input"
        type="number"
        min="0"
        step="0.01"
        value={inputValue}
        onChange={handleChange}
        placeholder={t("js.visitors.tam_calculator.filters.acv.placeholder")}
        className="tam-calculator__acv-input"
      />
    </div>
  )
}

